import { jsx as _jsx } from "react/jsx-runtime";
import { withClassName } from '@a-type/ui';
import { lazy, Suspense } from 'react';
import cls from './TopographyBackground.module.css';
const LazyTopography = lazy(() => import('./Topography.js'));
function Topography(props) {
    return (_jsx(Suspense, { fallback: _jsx("div", { className: cls.root }), children: _jsx(LazyTopography, { ...props }) }));
}
export const TopographyBackground = withClassName(Topography, cls.root);
//# sourceMappingURL=TopographyBackground.js.map